import { SectionTitleColor, SectionTitleSize } from "./SectionTitle.types";

export const SECTION_TITLE_SIZE_CLASSES: Record<SectionTitleSize, string> = {
  sm: "text-xs",
  md: "text-sm",
  lg: "",
} as const;

export const SECTION_TITLE_COLOR_CLASSES: Record<SectionTitleColor, string> = {
  primary: "text-[#3F4757]",
  secondary: "",
} as const;
